import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Helper function to safely log events
export const safeLogEvent = async (eventName, eventParams = {}) => {
  try {
    if (!analytics) {
      return false;
    }
    // VITE_FIREBASE_DEBUG_MODE=true sends events to Firebase DebugView (local testing only).
    const debugParams =
      import.meta.env.VITE_FIREBASE_DEBUG_MODE === 'true' ? { debug_mode: true } : {};
    await logEvent(analytics, eventName, { ...eventParams, ...debugParams });
    console.log(`✅ Analytics event logged`);
    return true;
  } catch (error) {
    console.error(`❌ Failed to log analytics event`);
    return false;
  }
};
// Ensure authentication is ready before fetching user data
onAuthStateChanged(auth, (user) => {
  if (user) {
    user
      .getIdTokenResult()
      .then((idTokenResult) => {
        console.log('User Claims:', idTokenResult.claims);
      })
      .catch((error) => {
        console.error('Error getting token:', error);
      });
  } else {
    // console.log('No user logged in');
  }
});

export { app, analytics, logEvent };
